import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { flyoutFeatureKey, flyoutReducer } from './flyout.reducer';

@NgModule({
    declarations: [],
    imports: [CommonModule, StoreModule.forFeature(flyoutFeatureKey, flyoutReducer)]
})
export class FlyoutStoreModule {}
